<template>
  <v-form @submit="save">
    <v-layout row wrap>
      <v-flex
        :class="field.classes"
        v-for="field in shownInputFields"
        :key="field.name"
      >
        <v-autocomplete
          v-if="field.type === 'select'"
          :label="field.name"
          v-model="field.value"
          :items="field.items"
          item-text="name"
          @input="update"
          :return-object="true"
        />
        <v-autocomplete
          v-if="field.type === 'select-value'"
          :label="field.name"
          v-model="field.value"
          :items="field.items"
          item-text="name"
          @input="update"
        />
        <v-text-field
          v-else-if="field.type === 'text'"
          type="text"
          :label="field.name"
          v-model="field.value"
          @input="update"
          :counter="field.maxLen"
          :maxlength="field.maxLen"
        />
        <v-text-field
          v-else-if="field.type === 'email'"
          type="email"
          :label="field.name"
          v-model="field.value"
          @input="update"
        />
        <v-text-field
          v-else-if="field.type === 'number'"
          type="number"
          :label="field.name"
          v-model="field.value"
          @input="update"
        />
        <v-text-field
          v-else-if="field.type === 'password'"
          type="password"
          :label="field.name"
          v-model="field.value"
          @input="update"
        />
        <v-checkbox
          v-else-if="field.type === 'checkbox'"
          :label="field.name"
          v-model="field.value"
          @input="update"
          color="secondary"
        />
        <v-radio-group
          v-else-if="field.type === 'radio'"
          v-model="field.value"
          @change="update"
        >
          <v-radio
            v-for="option in field.items"
            :key="option"
            :value="option"
            :label="option"
          >
          </v-radio>
        </v-radio-group>
        <v-subheader v-else-if="field.type === 'label'" class="labelField">
          {{ field.name }}
        </v-subheader>
      </v-flex>
    </v-layout>
    <slot name="submit">
      <v-btn block round color="info" class="mt-3" type="submit">Save</v-btn>
    </slot>
  </v-form>
</template>

<script>
export default {
  name: "PCForm",
  props: ["classes", "fields"],
  data() {
    return {
      formClasses: this.classes,
      inputFields: this.fields,
    };
  },
  computed: {
    shownInputFields() {
      const result = this.inputFields.filter((x) =>
        typeof x.hide === "undefined" ? true : !x.hide()
      );
      return result;
    },
  },
  methods: {
    save(evt) {
      evt.preventDefault();
      this.$emit("save", this.inputFields);
    },
    update() {
      this.inputFields = [...this.inputFields];
      this.$emit("update", this.inputFields);
    },
  },
  watch: {
    fields(newVal) {
      this.inputFields = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.border-right {
  border-right: 1px solid #d8d8d8;
}
.labelField {
  margin-left: -16px;
}
</style>
